"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tools_defaults_1 = require("./tools-defaults");
const VISUALIZATION_VERSION = 2;
function migrateVisualizations(visualization, toolId) {
    const version = visualization.version || 1;
    if (version >= VISUALIZATION_VERSION) {
        return;
    }
    let migrateFunction = null;
    switch (toolId) {
        case tools_defaults_1.tools.player.id:
            migrateFunction = _migratePlayer;
            break;
        case tools_defaults_1.tools.measurer.id:
            migrateFunction = _migrateMeasurer;
            break;
        case tools_defaults_1.tools.trail.id:
            migrateFunction = _migrateTrailOrTrace;
            break;
        case tools_defaults_1.tools.futureTrail.id:
            migrateFunction = _migrateTrailOrTrace;
            break;
        case tools_defaults_1.tools.circle.id:
            migrateFunction = _migrateCircle;
            break;
        case tools_defaults_1.tools.shape.id:
            migrateFunction = _migrateShape;
            break;
        case tools_defaults_1.tools.arrow.id:
            migrateFunction = _migrateArrow;
            break;
        case tools_defaults_1.tools.dragger.id:
            migrateFunction = _migrateDragger;
            break;
        default:
            break;
    }
    if (migrateFunction) {
        visualization.options = Object.keys(visualization.options).reduce((acc, key) => {
            migrateFunction(acc, key, visualization.options[key]);
            return acc;
        }, {});
    }
}
function _migratePlayer(acc, key, value) {
    switch (key) {
        case 'ring':
            acc.ringFill = value;
            acc.ringBorder = value;
            break;
        case 'ringColor':
            acc.ringFillColor = value;
            acc.ringBorderColor = value;
            break;
        default:
            acc[key] = value;
            break;
    }
}
function _migrateMeasurer(acc, key, value) {
    switch (key) {
        case 'distances':
            acc.distance = value;
            break;
        case 'color':
            acc.borderColor = value;
            acc.distanceColor = value;
            acc.fillColor = value;
            acc.ringBorderColor = value;
            acc.ringFillColor = value;
            break;
        case 'filled':
            // Deprecated
            break;
        default:
            acc[key] = value;
            break;
    }
}
function _migrateCircle(acc, key, value) {
    switch (key) {
        case 'color':
            acc.fillColor = value;
            acc.borderColor = value;
            break;
        case 'opacity':
            acc.borderOpacity = value;
            acc.fillOpacity = value;
            break;
        default:
            acc[key] = value;
            break;
    }
}
function _migrateTrailOrTrace(acc, key, value) {
    switch (key) {
        case 'color':
            acc.color = value;
            acc.ringBorderColor = value;
            acc.ringFillColor = value;
            break;
        default:
            acc[key] = value;
            break;
    }
}
function _migrateShape(acc, key, value) {
    switch (key) {
        case 'distances':
            acc.distance = value;
            break;
        case 'color':
            acc.borderColor = value;
            acc.distanceColor = value;
            acc.fillColor = value;
            break;
        case 'filled':
        case 'notFilled':
            // Deprecated
            break;
        default:
            acc[key] = value;
            break;
    }
}
function _migrateArrow(acc, key, value) {
    switch (key) {
        case 'color':
            acc.distanceColor = value;
            acc.color = value;
            break;
        case 'filled':
        case 'notFilled':
            // Deprecated
            break;
        default:
            acc[key] = value;
            break;
    }
}
function _migrateDragger(acc, key, value) {
    switch (key) {
        case 'color':
            acc.distanceColor = value;
            acc.color = value;
            break;
        case 'filled':
        case 'notFilled':
            // Deprecated
            break;
        default:
            acc[key] = value;
            break;
    }
}
exports.default = migrateVisualizations;
